const guiColors = {
    'motion-primary': '#4800cc',
    'motion-primary-transparent': '#4800cce6',
    'motion-tertiary': '#2D00A8',

    'looks-secondary': '#4800cc',
    'looks-secondary-light': '#9a69f3',
    'looks-secondary-lighter': '#eadefe',
    'looks-transparent': '#5208D959',
    'looks-light-transparent': '#6B30D926',
    'looks-secondary-dark': '#220099',
    'looks-secondary-darker': '#1d017c',
    'looks-secondary-deep-dark': '#0b012e',

    'extensions-primary': 'hsla(261, 100%, 38%, 1)',
    'extensions-tertiary': 'hsla(261, 100%, 15%, 1)',
    'extensions-transparent': 'hsla(261, 100%, 38%, 0.43)',
    'extensions-light': 'hsla(261, 100%, 56%, 1)',

    'drop-highlight': '#7E4ED9'
};

const blockColors = {
    checkboxActiveBackground: '#4800cc',
    checkboxActiveBorder: '#3100AD'
};

export {
    guiColors,
    blockColors
};